import { motion, useScroll, useSpring } from 'framer-motion';

/**
 * 2px scroll progress bar pinned to the top of the viewport. Purely
 * decorative — motion-only, no functional value — respects reduced-motion
 * automatically via useSpring's stiff config being effectively imperceptible
 * when the browser disables transitions.
 */
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const width = useSpring(scrollYProgress, { stiffness: 140, damping: 30, restDelta: 0.001 });
  return (
    <motion.div
      style={{ scaleX: width, transformOrigin: '0 0' }}
      className="fixed top-0 left-0 right-0 h-[2px] z-50 bg-gradient-to-r from-[color:var(--color-brand)] via-[color:var(--color-brand-glow)] to-[color:var(--color-brand-deep)]"
      aria-hidden
    />
  );
}
